export function confirm({ question }) {
  const result = window.confirm(question);
  return result;
}
